module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.isReadOnly) ? _c('span', [_vm._v("修改")]) : _vm._e(), _vm._v("下单")]), _vm._v(" "), _c('el-form', [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "选择套餐"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changePackage
    },
    model: {
      value: (_vm.form.PackageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "PackageId", $$v)
      },
      expression: "form.PackageId"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 10002
    }
  }, [_vm._v("2018联帮在家ABC")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 10003
    }
  }, [_vm._v("联帮在家Q3Q4续费")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId == 10002),
      expression: "form.PackageId==10002"
    }],
    attrs: {
      "label": "订单类型"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeOrderSource
    },
    model: {
      value: (_vm.form.OrderSource),
      callback: function($$v) {
        _vm.$set(_vm.form, "OrderSource", $$v)
      },
      expression: "form.OrderSource"
    }
  }, _vm._l((_vm.orderTypes), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1), _vm._v(" "), (_vm.form.OrderSource == 4) ? _c('el-form-item', {
    attrs: {
      "label": "选择团购人数"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeGroups
    },
    model: {
      value: (_vm.form.GroupPeopleNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "GroupPeopleNum", $$v)
      },
      expression: "form.GroupPeopleNum"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1) : _vm._e()], 1), _vm._v(" "), (_vm.form.OrderSource == 3) ? _c('h4', [_vm._v("转介绍人信息")]) : _vm._e()]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.OrderSource == 4 && !_vm.isReadOnly),
      expression: "form.OrderSource==4&&!isReadOnly"
    }]
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.currentOrderNum),
      callback: function($$v) {
        _vm.currentOrderNum = $$v
      },
      expression: "currentOrderNum"
    }
  }, _vm._l((_vm.orderNum), function(item, index) {
    return _c('el-radio-button', {
      attrs: {
        "label": index + 1
      }
    }, [_vm._v("订单" + _vm._s(index + 1))])
  }))], 1)], 1), _vm._v(" "), _vm._l((_vm.orderNum), function(order, index) {
    return _c('OrderInfo', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.OrderSource == 3 || (index + 1) == _vm.currentOrderNum),
        expression: "form.OrderSource==3||(index+1)==currentOrderNum"
      }],
      ref: 'OrderInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "value": order.orderInfoData,
        "packageId": _vm.form.PackageId,
        "hideShowArea": order.flag,
        "OrderSouce": _vm.form.OrderSource,
        "myIndex": (index + 1),
        "isReadOnly": _vm.isReadOnly,
        "total": _vm.orderNum.length
      }
    })
  }), _vm._v(" "), _c('h4', [_vm._v("涉及物料")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "90%",
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Type",
      "label": "物料类型",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "content-rowspan"
        }, _vm._l((scope.row.Details), function(item) {
          return _c('div', [_vm._v(" " + _vm._s(item.option1))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "content-rowspan"
        }, _vm._l((scope.row.Details), function(item) {
          return _c('div', [_vm._v(" " + _vm._s(item.num))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "content-rowspan"
        }, _vm._l((scope.row.Details), function(item) {
          return _c('div', [_vm._v(" " + _vm._s(item.remark))])
        }))]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交订单")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "width": "30%",
      "showClose": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("已下单成功！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("继续下单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToList
    }
  }, [_vm._v("跳转查看订单")])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01632f4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/LBHomeOrder/index.vue
// module id = 1367
// module chunks = 1